import _extends from "@babel/runtime/helpers/extends";
import { createScopedElement } from "../../lib/jsxRuntime";
export var Icon48CancelCircle = function Icon48CancelCircle(props) {
  return createScopedElement("svg", _extends({
    vkuiClass: "Icon",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), createScopedElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 24c0 8.837-7.163 16-16 16S8 32.837 8 24 15.163 8 24 8s16 7.163 16 16Zm-10.08-4.33a1.125 1.125 0 0 0-1.59-1.59L24 22.409l-4.33-4.33a1.125 1.125 0 0 0-1.59 0l-.101.116a1.125 1.125 0 0 0 .1 1.476L22.41 24l-4.33 4.33a1.125 1.125 0 0 0 1.591 1.59L24 25.591l4.33 4.33c.439.439 1.151.439 1.59 0l.101-.116a1.125 1.125 0 0 0-.1-1.476L25.59 24l4.33-4.33Z",
    fill: "currentColor"
  }));
};
//# sourceMappingURL=Icon48CancelCircle.js.map